module.exports = "<p class=\"text-center loader\" style=\"font-size: 1.4em;padding-top: 20px\">\n    <i class=\"icon icon-arrows animate-spin\"></i>\n</p>\n"